
import { ModelBase } from "@models/UpsertableBase";
import {
  Alignment,
  alignmentString, 
} from "@dndModels";
import { DataType } from "@dndModels/Types";
import CommonUtilities from "@utilities/common_utilities";

const common_util = CommonUtilities.getInstance();

export class Deity extends ModelBase {
  data_type: DataType = "deity";
  alignment: Alignment = { 
    order: "Any", 
    moral: "Any" 
  };
  pantheons: string[] = [];
  titles: string[] = [];
  derogatory_titles: string[] = [];
  symbol: string = "";
  settings: string[] = []; // Forgotten Realms, Eberron, Dragonlance, Ravenloft, Spelljammer, etc
  native_planes: string[] = []; // Where they live
  divine_domains: string[] = []; // The domains they typically are associated with and their clerics can take
  associated_creatures: string[] = []; // IDs of creatures associated with this deity

  get moral() {
    return this.alignment.moral;
  }
  get order() {
    return this.alignment.order;
  }
  get alignment_string() {
    return alignmentString(this.alignment);
  }
  get divine_domains_string() {
    return common_util.customJoin({ arr: this.divine_domains, separator: ", ", lastSeparator: ", and ", onlySeparator: " and " });
  }

  constructor(obj?: any) {
    super(obj);
    if (obj) {
      this.alignment = obj.alignment ? obj.alignment : { 
        order: "Any", 
        moral: "Any" 
      };
      this.pantheons = obj.pantheons ? obj.pantheons : obj.pantheon ? [obj.pantheon] : [];
      this.titles = obj.titles ? obj.titles : obj.title ? [obj.title] : [];
      this.derogatory_titles = obj.derogatory_titles ? obj.derogatory_titles : [];
      this.symbol = obj.symbol ? obj.symbol : "";
      this.settings = obj.settings ? obj.settings : [];
      this.native_planes = obj.native_planes ? obj.native_planes : [];
      this.divine_domains = obj.divine_domains ? obj.divine_domains : [];
      this.associated_creatures = obj.associated_creatures ? obj.associated_creatures : [];
    }
  }

  toDBObj(): any {
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      alignment: this.alignment,
      pantheons: this.pantheons,
      titles: this.titles,
      derogatory_titles: this.derogatory_titles,
      symbol: this.symbol,
      settings: this.settings,
      native_planes: this.native_planes,
      divine_domains: this.divine_domains,
      associated_creatures: this.associated_creatures
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      alignment: this.alignment,
      pantheons: this.pantheons,
      titles: this.titles,
      derogatory_titles: this.derogatory_titles,
      symbol: this.symbol,
      settings: this.settings,
      native_planes: this.native_planes,
      divine_domains: this.divine_domains,
      associated_creatures: this.associated_creatures
    };
  }

  copy(copyMe: Deity, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.alignment = {...copyMe.alignment};
    this.pantheons = [...copyMe.pantheons];
    this.titles = [...copyMe.titles];
    this.derogatory_titles = [...copyMe.derogatory_titles];
    this.symbol = copyMe.symbol;
    this.settings = [...copyMe.settings];
    this.native_planes = [...copyMe.native_planes];
    this.divine_domains = [...copyMe.divine_domains];
    this.associated_creatures = [...copyMe.associated_creatures];
  }

  clone(drop_ids = false): Deity {
    const new_obj = new Deity();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}